import bannerStrand from '../../assets/images/Banner_Strand.png'
import usaFlag from '../../assets/images/usa-flag.svg'
import gameTimelineGraphic from '../../assets/images/GAME_Timeline-graphic.png'

export const gameContent = {
    "sys": {
      "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
      {
        "fields": {
          "name": "Group Advantage Marketing Engine (GAME)​",
          "title": "Group Advantage Marketing Engine (GAME)​",
          "slug": "game",
          "content": {
            "metadata": {
              "tags": [],
              "concepts": []
            },
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "n9bebhw263o0"
                }
              },
              "id": "1hFZIPKlRZHcqtPjoq3cIu",
              "type": "Entry",
              "createdAt": "2024-06-06T13:25:10.470Z",
              "updatedAt": "2024-06-06T13:25:10.470Z",
              "environment": {
                "sys": {
                  "id": "sandbox",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "publishedVersion": 4,
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "richTextContentPageTemplate"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "name": "GAME > Content ",
              "modules": [
                {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "5iOZJVfPLRHltKZYu6XLDV",
                    "type": "Entry",
                    "createdAt": "2024-06-06T13:25:00.461Z",
                    "updatedAt": "2024-06-07T20:20:11.416Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 14,
                    "revision": 4,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "bannerComponent"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "GAME > Content > Banner",
                    "headline": "The Moderna Group Advantage Portal  ",
                    "backgroundImage": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "5zfGJA7or5WGcLdYi4Qde",
                        "type": "Asset",
                        "createdAt": "2022-10-28T18:53:29.208Z",
                        "updatedAt": "2022-10-28T18:53:29.208Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 6,
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Banner BG Strand Top",
                        "description": "",
                        "file": {
                          "url": bannerStrand,
                          "details": {
                            "size": 47693,
                            "image": {
                              "width": 1920,
                              "height": 511
                            }
                          },
                          "fileName": "Banner BG Strand Top .png",
                          "contentType": "image/png"
                        }
                      }
                    },
                    "message": "The Moderna Group Advantage Portal  ",
                    "country": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "7iOWBmppZrkK5s40UUIzOV",
                        "type": "Entry",
                        "createdAt": "2023-09-28T22:24:03.948Z",
                        "updatedAt": "2023-09-28T22:24:03.948Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 3,
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "country"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "name": "United States",
                        "isocode": "US",
                        "flag": {
                          "metadata": {
                            "tags": [],
                            "concepts": []
                          },
                          "sys": {
                            "space": {
                              "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                              }
                            },
                            "id": "3aYCbZJiL8aoEKRdhjOXyy",
                            "type": "Asset",
                            "createdAt": "2023-05-24T22:54:50.939Z",
                            "updatedAt": "2023-05-24T22:54:50.939Z",
                            "environment": {
                              "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                              }
                            },
                            "publishedVersion": 5,
                            "revision": 1,
                            "locale": "en-US"
                          },
                          "fields": {
                            "title": "usa flag",
                            "description": "USA Flag",
                            "file": {
                              "url": usaFlag,
                              "details": {
                                "size": 2487,
                                "image": {
                                  "width": 36,
                                  "height": 26
                                }
                              },
                              "fileName": "usa_flag.svg",
                              "contentType": "image/svg+xml"
                            }
                          }
                        },
                        "locales": [
                          "en-US"
                        ]
                      }
                    }
                  }
                },
                {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "2DyJH2iPzxnQWniWAk7Kab",
                    "type": "Entry",
                    "createdAt": "2024-06-06T13:25:08.436Z",
                    "updatedAt": "2024-06-10T20:44:06.753Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 97,
                    "revision": 26,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "richTextContentComponent"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "GAME > Content > Rich Text ",
                    "content": {
                      "nodeType": "document",
                      "data": {},
                      "content": [
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Welcome to Your Exclusive Resource Center ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "As part of our commitment to enhancing healthcare delivery, we’ve created an exclusive suite of resources that you can deliver to your partner practices to help them enhance their vaccination efforts.  ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Bookmark this page and check back often – you'll find all the latest news on vaccine availability, ordering, and shipping, along with a range of materials specifically developed to aid practices in reaching and educating both staff and patients effectively during the vaccination season. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "hr",
                          "data": {},
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Contract Announcement:  ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Contract details are still being finalized. When ready, you’ll find a PDF outlining the contract announcement here that you can share with your members, along with an email template you can send out with your logo added.  ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "hr",
                          "data": {},
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "2024-2025 Vaccine Schedule Key Dates ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "5xB9gwsnDpWm4ASXjvWFhZ",
                                "type": "Asset",
                                "createdAt": "2024-06-06T20:08:02.823Z",
                                "updatedAt": "2024-06-25T16:58:48.513Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 19,
                                "revision": 5,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "GAME Timeline Graphic",
                                "description": "",
                                "file": {
                                  "url": gameTimelineGraphic,
                                  "details": {
                                    "size": 348128,
                                    "image": {
                                      "width": 3045,
                                      "height": 752
                                    }
                                  },
                                  "fileName": "GAME_Timeline-graphic.png",
                                  "contentType": "image/png"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        }
                      ]
                    },
                    "printButtonLabel": "Print",
                    "country": "[Circular Reference]"
                  }
                }
              ]
            }
          }
        },
        "sys": {
          "id": "pmizZPxOVpTC7eH87lkBP",
          "type": "Entry"
        }
      }
    ],
    "includes": {
      "Entry": [
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]"
      ],
      "Asset": [
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]"
      ]
    }
}